import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ClientI18nService } from './client-i18n.service';

@Pipe({
  name: 'clientTranslate',
  pure: false
})
export class ClientTranslatePipe implements PipeTransform {
  private lastLanguageAttempted: string | null = null;
  private attemptedCombinedLoad: boolean = false;

  constructor(
    private ngxTranslate: TranslateService,
    private clientI18nService: ClientI18nService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  transform(key: string): string {
    if (!key) return '';

    const activeLang = this.ngxTranslate.currentLang || this.ngxTranslate.defaultLang || 'en';

    // Ensure combined dictionary is loaded once
    if (!this.attemptedCombinedLoad) {
      this.attemptedCombinedLoad = true;
      this.clientI18nService
        .ensureCombinedDictionaryLoaded()
        .then(() => this.changeDetectorRef.markForCheck())
        .catch(() => this.changeDetectorRef.markForCheck());
    }

    // Only load per-language files if combined dictionary is NOT available
    if (!this.clientI18nService.isCombinedLoaded()) {
      if (this.lastLanguageAttempted !== activeLang && !this.clientI18nService.hasAnyDictionaryForLanguage(activeLang)) {
        this.lastLanguageAttempted = activeLang;
        this.clientI18nService
          .loadDictionariesForLanguage(activeLang)
          .then(() => this.changeDetectorRef.markForCheck())
          .catch(() => this.changeDetectorRef.markForCheck());
      }
    }

    const clientText = this.clientI18nService.translate(activeLang, key);
    return clientText != null ? clientText : key;
  }
}


